export const MOBILE_LAYOUT_MAX_WIDTH_QUERY = '(min-width:1250px)';
export const WIDTH_BREAKPOINT_LG = '1200px';
export const WIDTH_BREAKPOINT_MD = '960px';
export const WIDTH_BREAKPOINT_SM = '640px';
export const WIDTH_BREAKPOINT_XS = '360px';
